define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var AccountManagerModel = /** @class */ (function () {
        function AccountManagerModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, AccountManagerModel.Mapping, self);
            }
        }
        AccountManagerModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new AccountManagerModel(options.data);
            }
        };
        return AccountManagerModel;
    }());
    return AccountManagerModel;
});
//# sourceMappingURL=AccountManagerModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/AccountManagerModel.js
// module id = 233
// module chunks = 2